<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <v-card
    class="text-body-2 px-4 py-6"
    elevation="0"
    height="360"
    outlined
    style="position: relative"
  >
    <div
      class="d-flex flex-column"
      style="height: 100%"
    >
      <div
        class="d-flex align-center"
        style="height: 41px"
      >
        <v-card
          :color="color"
          class="mr-4"
          elevation="0"
          height="18"
          width="4"
        />
        <div
          class="text-h4 font-weight-bold"
          @click="$emit('click')"
        >
          {{ name }} {{ $t('menu') }}
        </div>
        <v-spacer />
        <v-menu
          v-if="!isDefaultConsumeType"
          close-on-content-click
          left
          offset-overflow
          offset-y
          rounded
        >
          <template #activator="{on,attrs}">
            <v-btn
              icon
              style="border-radius: 12px"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>
                mdi-dots-vertical
              </v-icon>
            </v-btn>
          </template>
          <v-list
            outlined
            width="200px"
          >
            <v-list-item-group>
              <v-list-item @click="$emit('click')">
                <v-list-item-title>{{ $t('edit') }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="$emit('copy')">
                <v-list-item-title>{{ $t('copy') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="!cantDelete"
                @click="deleteItem"
              >
                <v-list-item-title>{{ $t('delete') }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="$emit('configuration')">
                <v-list-item-title>{{ $t('BuffetBundleSettings') }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="$emit('changehotpotstatus')">
                <v-list-item-title>
                  <div class="d-flex">
                    <div>{{ $t('HotPotBuffet') }}</div>
                    <v-spacer />
                    <v-icon
                      v-if="isHotpot === '1'"
                      @click.stop="$emit('changehotpotstatus')"
                    >
                      mdi-checkbox-outline
                    </v-icon>
                    <v-icon
                      v-else
                      @click.stop="$emit('changehotpotstatus')"
                    >
                      mdi-checkbox-blank-outline
                    </v-icon>
                  </div>
                </v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </div>

      <v-spacer />
      <div v-if="!isDefaultConsumeType">
        <template v-if="isRestaurantVersion">
          <v-card
            class="pa-1 px-1 d-flex  mt-4"
            flat
          >
            <v-spacer />
            <div class="text-right d-flex align-center">
              <v-icon
                v-if="isHotpot === '1'"
                class="mt-1"
              >
                mdi-food-takeout-box-outline
              </v-icon>
            </div>
          </v-card>
          <v-card
            class="pa-1 px-1 d-flex"
            flat
          >
            <div class="text-body-2">
              id
            </div>
            <v-spacer />
            <div class="text-right d-flex align-center">
              <div>
                {{ consumeTypeId }}
              </div>
              <v-icon
                size="18"
              >
                mdi-information-variant
              </v-icon>
            </div>
          </v-card>
          <v-card
            class="pa-1 px-1 d-flex"
            flat
            @click.stop="$emit('time-click')"
          >
            <div class="text-body-2">
              {{ $t('availableTime') }}
            </div>
            <v-spacer />
            <div class="text-right d-flex align-center">
              <div v-if="time>0">
                {{ time }}
              </div>
              <v-chip
                v-else
                color="error"
                small
              >
                <span
                  class="text-truncate"
                  style="max-width: 60px;"
                >
                  ！{{ $t('unsetting') }}
                </span>
              </v-chip>

              <v-icon
                v-if="time>0"
                size="18"
              >
                mdi-chevron-right
              </v-icon>
            </div>
          </v-card>
          <v-card
            class="pa-1 px-1 d-flex"
            flat
            @click.stop="$emit('price-click')"
          >
            <div class="text-body-2">
              {{ $t('buffetPrice') }}
            </div>
            <v-spacer />
            <div class="text-right d-flex align-center">
              <div v-if="priceCount>0">
                {{ priceCount }}{{ $t('species') }}
              </div>
              <v-chip
                v-else
                color="error"
                small
              >
                <span
                  class="text-truncate"
                  style="max-width: 60px;"
                >
                  ！{{ $t('unsetting') }}
                </span>
              </v-chip>
              <v-icon
                v-if="priceCount>0"
                size="18"
              >
                mdi-chevron-right
              </v-icon>
            </div>
          </v-card>
          <v-card
            class="pa-1 px-1 d-flex "
            flat
            @click.stop="$emit('setting-click')"
          >
            <div class="text-body-2">
              {{ $t('dinnerSet') }}
            </div>
            <v-spacer />
            <div class="text-right d-flex align-center">
              <div v-if="hasSetting">
                {{ $t('edit') }}
              </div>
              <v-chip
                v-else
                color="error"
                small
              >
                <span
                  class="text-truncate"
                  style="max-width: 60px;"
                >
                  ！{{ $t('unsetting') }}
                </span>
              </v-chip>
              <v-icon
                v-if="hasSetting"
                size="18"
              >
                mdi-chevron-right
              </v-icon>
            </div>
          </v-card>
        </template>
        <template v-else>
          <div
            class="text-body-2 px-1"
          >
            <p v-html="$t('DIYMenu')" />
          </div>
        </template>
      </div>
      <div
        v-else
        class="text-body-2 px-1"
      >
        <p v-html="$t('noNeedSet')" />
      </div>
      <v-card
        class="pa-4 mt-4"
        color="#eee"
        elevation="0"
        @click.stop="$emit('dish-click')"
      >
        <div class="text-body-2">
          {{ $t('goodsOfMenu') }}
        </div>

        <div class="text-right d-flex mt-4 align-center">
          <div>
            {{ dishesShow }}{{ $t('one(unit)') }}
          </div>
          <v-spacer />
          <v-icon
            class="mt-1"
            size="18"
          >
            mdi-chevron-right
          </v-icon>
        </div>
      </v-card>
    </div>
  </v-card>
</template>

<script>
import { sureToDelete } from '@/model/utils/utils'
import { isRestaurant } from '@/model/global/GlobalSettings'

export default {
  name: 'ConsumeTypeInfoCard',
  components: {},
  props: {
    consumeTypeId: {
      type: Number
    },
    consumeTypeInfo: {}
  },
  data: function () {
    return {
      isRestaurantVersion: isRestaurant()
    }
  },
  computed: {
    cantDelete () {
      return [1, 2, 5, 7].includes(this.consumeTypeId)
    },
    isHotpot () {
      return this.consumeTypeInfo?.isHotpot
    },
    name () {
      return this.consumeTypeInfo?._langsname ?? '-'
    },
    time () {
      return this.consumeTypeInfo?.timeCount ?? 0
    },
    dishesShow () {
      return this.consumeTypeInfo?.dishCount ?? 0
    },
    priceCount () {
      return this.consumeTypeInfo?.priceCount ?? 0
    },
    hasSetting () {
      return (this.consumeTypeInfo?.settingCount ?? 0) === '1'
    },
    color () {
      return this.consumeTypeInfo?.color ?? '#ffffff'
    },
    isDefaultConsumeType () {
      return false
    }
  },
  methods: {
    async deleteItem () {
      await sureToDelete(() => {
        this.$emit('delete')
      })
    }
  }

}
</script>

<style scoped>

</style>
